<template>
    <div class="drawerLayer" v-show="visible">
        <div class="mask" @click="close();"></div>
        <div class="bottomDrawer white_bg" style="min-height: 420px; padding-bottom: 34px;">
            <div class="paddingH16">
                <header class="header paddingV16">
                    <div class="flexLayout">
                        <div style="width: 16px;"></div>
                        <div class="flexItem alignCenter grey10 fWeight600">{{title}}</div>
                        <div style="width: 16px;">
                            <i class="icon closeIcon" @click="close()"></i>
                        </div>
                    </div>
                </header>
                <div class="body" style="padding-top: 16px; padding-bottom: 8px;">
                    <div class="alignC paddingV8 bold font14r">报名号</div>
                    <div class="bgF5F5F5 gold roundBorder8 font18r lineHeight24r18f breakWord hiddenScrollbar"
                         style="padding: 10px 15px; max-height: 60px; overflow: auto">
                        {{info ? info.applyNumber : ''}}
                    </div>
                    <div class="bgF5F5F5 font14r roundBorder8" style="margin-top: 14px; padding: 0 11px 15px;">
                        <table>
                            <tr>
                                <th width="80" class="darkgrey">　课程名</th>
                                <td class="color333">{{info ? info.title : ''}}</td>
                            </tr>
                            <tr>
                                <th class="darkgrey">课程时间</th>
                                <td class="color333">
<!--                                    {{info ? formatDate(info.startTime) : '未知'}}&nbsp;&nbsp;&nbsp;&nbsp;{{info ? formatTimeRange(info.startTime, info.endTime) : ''}}-->
                                    {{info ? formatDateTime(info.startTime) : '未知'}}&nbsp;&nbsp;至&nbsp;&nbsp;
                                    {{info ? formatDateTimeWithoutYear(info.endTime) : '未知'}}
                                </td>
                            </tr>
                            <tr>
                                <th class="darkgrey">课程地点</th>
                                <td class="color333">
                                    {{info ? info.city : ''}} | {{info ? info.address : ''}}
                                </td>
                            </tr>

                        </table>
                    </div>
                    <div style="margin-top: 40px;">
                        <button class="orangeButton block w100p font18r" style="height: 42px; line-height: 42px;"
                            @click="signIn()">签到</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import drawerPart from '@/components/part/drawerPart';

import appHelper from "@/util/appHelper";
import browserHelper from "@/util/browserHelper";
import moment from "moment";

const config = {

};

export default {
    name: "courseInfoDrawer",
    extends : drawerPart,
    props : {
        title : {
            type : String,
            default : '课程信息'
        },
        info : Object
    },
    methods : {
        formatTimeRange(startTime, endTime) {
            return moment(startTime).format('HH:mm') + '-' + moment(endTime).format('HH:mm');
        },
        formatDateTime : function (timestamp) {
            if (!timestamp)
            {
                return '';
            }
            return moment(timestamp).format('YYYY-MM-DD HH:mm');
        },
        formatDateTimeWithoutYear : function (timestamp) {
            if (!timestamp)
            {
                return '';
            }
            return moment(timestamp).format('MM-DD HH:mm');
        },
        signIn() {
            if (browserHelper.isWechat)
            {
                wx.scanQRCode({
                    needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                    scanType: ["qrCode"]
                });
            }
            else
            {
                appHelper.showHint('请手动切换到微信app，使用扫一扫功能。');
            }

        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    .closeIcon {
        width: 14px;
        height: 14px;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACFklEQVRoge2ZQU/bMBhALWCdhPgZvfnk7305k/MkdhgwumqI/vkxpE2CaTsgtaG7xCjqbEiKnWRSntRDqzp+L0nbNDZmYmIiCHBsrT0Z2sNaewIcdxqkqh+AP8CjiHzO5PYqIvIJeAR+q2rZdtwhcAts68daVc8zegZR1Qtg3fC4NcYcvDoQeAc8NAb6iIv82s8OlzvyW+DeGHPYdgNLEakCEdmPRGDPb4EnEbnqtCERWfUdISJXEfnVvhsMRgCXadWf5TfJ5BsbDkVsnHNf0qhnlG9MkC0iu3xjouQRIfl6jpuU7s0Jk0XE5FX1Ood7c+I3Rwwm3xDYO8I5txhU3rNPBLAEqsHlPV0iRifvaRMxWnnPSxEheWA88p5YROC1ClgO7RtERL4GflX/D3lPfdr8E1EfiXHLG2OMql4HTpvkF4BZeEF+/BEh+fr57uk0vojInq+AZeQzMZ6IiPzGObfw74lFJL/m70pMPvQHPBQhItVgEV3kPaOJAG66ynsGjxCRFfC0j7xnsIgU8p7eI1LKe3qLiMiv3yLvyR4Rk095szdbRB/ynuQRfcp7kkWo6qJveQ+BtYE6ot1KkbV2BvzalSfDHekYkTWCe2vtrM34A+B786uyz9UZj6qe70R8M22WmIwxpiiKU+AO+CEiZ3lV4zjnPgI/gbuiKE47DS7L8mg+n7/P5NYaa+2sLMujoT0mJsbKX2RBsPwpegpvAAAAAElFTkSuQmCC');
    }
}
.darkgrey {
    color: #5B616C;
}
.gold {
    color: #CB851E;
}
table {
    th, td{
        padding: 14px 0;
    }
    th {
        text-align: left;
    }
    td {
        border-bottom: 1px solid #F0F0F0;;
    }
}
</style>
